function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  className: "tickCircle",
  fill: "#004152",
  fillRule: "nonzero",
  d: "M24,12 C24,5.31428571 18.6857143,0 12,0 C5.31428571,0 0,5.31428571 0,12 C0,18.6857143 5.31428571,24 12,24 C18.6857143,24 24,18.6857143 24,12 Z"
});

var _ref3 = React.createElement("polygon", {
  className: "tickMark",
  fill: "#FFF",
  points: "7.434 11.036 5.566 12.696 10.463 18.208 18.843 8.308 16.935 6.692 10.417 14.392"
});

var SvgTickInCircleFilled = function SvgTickInCircleFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTickInCircleFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tick-in-circle-filled.598b6197.svg";
export { ForwardRef as ReactComponent };